// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/27993474/" + chunkId + "." + __webpack_require__.h() + ".v27993474.js";
};